module.exports = __webpack_public_path__ + "img/allocation_Token.3918dd12.svg";